import { Injectable } from '@angular/core';
import { retry, catchError } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { INotificationPreference } from '../../interfaces/notification/notification-preference';
import { Dictionary } from '../../classes/dictionary';
import { SharedService } from '../shared.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationPreferencesService {

  private readonly notificationPreferencesUrl: string = '/ui-pages/notif-prefs/{serialNumber}/{fld}';

  private readonly baseHeaders = new HttpHeaders()
    .set("request-origin", "csr-portal");

  constructor(
    private readonly http: HttpClient, 
    private readonly sharedService: SharedService       
  ) { }

  public getNotificationPreferences(region: string, serialNumber: string, fieldId: number): Observable<INotificationPreference[]> {
    console.log('getNotificationPreferences - region', region, 'serialNumber', serialNumber, 'fieldId', fieldId );
    let url = this.sharedService.getBaseUrlByRegion(region) + this.notificationPreferencesUrl
      .replace('{serialNumber}', serialNumber)
      .replace('{fld}', fieldId.toString());
    console.log('getNotificationPreferences - url', url);
    return this.http.get<INotificationPreference[]>(url, {headers: this.baseHeaders, responseType: 'json'})
    .pipe(
      catchError(this.sharedService.handleError)
    )
  }

  public modifyNotificationPreferences(region: string, serialNumber: string, fieldId: number, 
      notifPrefsDict: Dictionary): Observable<any> {
    let notifPrefs: string[] = [];
    let items = notifPrefsDict.items;
    for(let item in items) {
      if (items[item]) {
        notifPrefs.push(item);
      }
    }
    let url = this.sharedService.getBaseUrlByRegion(region) + this.notificationPreferencesUrl
      .replace('{serialNumber}', serialNumber)
      .replace('{fld}', fieldId.toString());
    return this.http.put<string[]>(url, notifPrefs, {headers: this.baseHeaders, responseType: 'json'}).pipe(
      catchError(this.sharedService.handleError)
    );
  }


}
